import * as Yup from 'yup';
import '../config/yup';

export default Yup.object().shape({
  os_number: Yup.string().matches(/^\d/, 'Deve iniciar com número').required(),
  customer_name: Yup.string()
    .matches(/^[a-zA-Z ]+$/)
    .required(),
  customer_contact: Yup.string()
    .matches(/\(([0-9]{2})\)( )([0-9]{1})( )([0-9]{4})(-)([0-9]{4})/)
    .required(),
  customer_certified_id: Yup.string().required(),
  ophthalmologist: Yup.string()
    .matches(/^[a-zA-Z ]+$/)
    .required(),
  salesman: Yup.string()
    .matches(/^[a-zA-Z ]+$/)
    .required(),
  technical_assistance: Yup.number().required(),
  manufacturer_id: Yup.string().required(),
  material_id: Yup.string().required(),
  product_id: Yup.string().required(),
  eye: Yup.number().min(0).max(2).required(),
  is_add: Yup.number().integer().min(0).max(1).required(),
  esf_right_eye: Yup.number()
    .nullable()
    .transform((value: string, originalValue: string) =>
      originalValue.trim() === '' ? null : value,
    )
    .when('eye', {
      is: (value: number) => value !== 0,
      then: Yup.number().required(),
    }),
  cil_right_eye: Yup.number()
    .nullable()
    .transform((value: string, originalValue: string) =>
      originalValue.trim() === '' ? null : value,
    )
    .when('eye', {
      is: (value: number) => value !== 0,
      then: Yup.number().required(),
    }),
  eixo_right_eye: Yup.number()
    .when('cil_right_eye', {
      is: (value: number) => value < 0,
      then: Yup.number().integer().min(1).max(180).required(),
    })
    .when('eye', {
      is: (value: number) => value !== 0,
      then: Yup.number().integer().required(),
    }),
  add_right_eye: Yup.number().when('is_add', {
    is: 1,
    then: Yup.number().when('eye', {
      is: (value: number) => value === 2,
      then: Yup.number()
        .min(0.5)
        .max(3.5)
        .required()
        .oneOf(
          [null, Yup.ref('add_left_eye')],
          'Deve ser igual ao olho esquerdo',
        ),
      otherwise: Yup.number().when('eye', {
        is: (value: number) => value === 1,
        then: Yup.number().min(0.5).max(3.5).required(),
      }),
    }),
  }),
  dnp_right_eye: Yup.number()
    .nullable()
    .transform((value: string, originalValue: string) =>
      originalValue.trim() === '' ? null : value,
    )
    .when('eye', {
      is: (value: number) => value !== 0,
      then: Yup.number().min(20).max(40).required(),
    }),
  height_right_eye: Yup.number().when('eye', {
    is: (value: number) => value !== 0,
    then: Yup.number().min(12).max(35).required(),
  }),
  esf_left_eye: Yup.number()
    .nullable()
    .transform((value: string, originalValue: string) =>
      originalValue.trim() === '' ? null : value,
    )
    .when('eye', {
      is: (value: number) => value !== 1,
      then: Yup.number().required(),
    }),
  cil_left_eye: Yup.number()
    .nullable()
    .transform((value: string, originalValue: string) =>
      originalValue.trim() === '' ? null : value,
    )
    .when('eye', {
      is: (value: number) => value !== 1,
      then: Yup.number().required(),
    }),
  eixo_left_eye: Yup.number()
    .when('cil_left_eye', {
      is: (value: number) => value < 0,
      then: Yup.number().integer().min(1).max(180).required(),
    })
    .when('eye', {
      is: (value: number) => value !== 1,
      then: Yup.number().integer().required(),
    }),
  add_left_eye: Yup.number().when('is_add', {
    is: 1,
    then: Yup.number().when('eye', {
      is: (value: number) => value === 2,
      then: Yup.number()
        .min(0.5)
        .max(3.5)
        .required()
        .oneOf(
          [null, Yup.ref('add_right_eye')],
          'Deve ser igual ao olho direito',
        ),
      otherwise: Yup.number().when('eye', {
        is: (value: number) => value === 0,
        then: Yup.number().min(0.5).max(3.5).required(),
      }),
    }),
  }),
  dnp_left_eye: Yup.number()
    .nullable()
    .transform((value: string, originalValue: string) =>
      originalValue.trim() === '' ? null : value,
    )
    .when('eye', {
      is: (value: number) => value !== 1,
      then: Yup.number().min(20).max(40).required(),
    }),
  height_left_eye: Yup.number().when('eye', {
    is: (value: number) => value !== 1,
    then: Yup.number().min(12).max(35).required(),
  }),
  model: Yup.string().when('measures', {
    is: 1,
    then: Yup.string().required(),
  }),
  /* frame: Yup.string().when('measures', {
    is: 1,
    then: Yup.string().required(),
  }), */
  frame: Yup.string().required('Campo armação é obrigatório'),
  reference: Yup.string().when('measures', {
    is: 1,
    then: Yup.string().required(),
  }),
  horizontal: Yup.number().when('measures', {
    is: 1,
    then: Yup.number().min(25).max(75).required(),
  }),
  vertical: Yup.number().when('measures', {
    is: 1,
    then: Yup.number().min(20).max(55).required(),
  }),
  po: Yup.number().when('measures', {
    is: 1,
    then: Yup.number().min(15).max(25).required(),
  }),
  diagonal: Yup.number().when('measures', {
    is: 1,
    then: Yup.number().min(25).max(80).required(),
  }),
  coloring_type: Yup.string().when('coloring', {
    is: 1,
    then: Yup.string()
      .matches(/^[a-zA-Z\d ]+$/)
      .required(),
  }),
  antireflection_type: Yup.string().when('antireflection', {
    is: 1,
    then: Yup.string()
      .matches(/^[\dA-zÀ-ú().\-\/ +]+$/gim) // eslint-disable-line
      .required(),
  }),
  observations: Yup.string().matches(/^$|^[a-zA-Z\d\s.,-/]+$/g),
  print_prisma: Yup.number().integer().min(0).max(1).required(),
  right_base: Yup.number()
    .transform(value => (Number.isNaN(value) ? 0 : value))
    .min(0)
    .max(4),
  right_base_quantity: Yup.number()
    .transform(value => (Number.isNaN(value) ? 0 : value))
    .min(0)
    .max(10),
  left_base: Yup.number()
    .transform(value => (Number.isNaN(value) ? 0 : value))
    .min(0)
    .max(4),
  left_base_quantity: Yup.number()
    .transform(value => (Number.isNaN(value) ? 0 : value))
    .min(0)
    .max(10),
});
